import React from "react";
import { cn } from "ui/lib/utils";

type ChipProps = {
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  /** A radio inside a radiogroup, rather than a toggle. */
  radio?: boolean;
  /** A swatch before the label, e.g. an effort level's colour. */
  color?: string;
  className?: string;
  children: React.ReactNode;
};

/** One choice in a set of choices in a sheet: a toggle, or a radio. */
export const Chip = ({
  selected,
  onClick,
  disabled,
  radio,
  color,
  className,
  children,
}: ChipProps) => (
  <button
    type="button"
    disabled={disabled}
    role={radio ? "radio" : undefined}
    aria-checked={radio ? selected : undefined}
    aria-pressed={radio ? undefined : selected}
    onClick={onClick}
    className={cn(
      "inline-flex min-h-11 max-w-full shrink-0 items-center gap-2 rounded-full border px-4 text-left text-[15px] transition-colors disabled:opacity-40",
      selected
        ? "border-white/40 bg-white/[0.1] text-white"
        : "border-white/[0.1] text-white/70 active:bg-white/[0.06]",
      className
    )}
  >
    {color ? (
      <span
        aria-hidden="true"
        className="size-2.5 shrink-0 rounded-full"
        style={{ backgroundColor: color }}
      />
    ) : null}
    {children}
  </button>
);
